import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

export interface QuestionDiff {
  diffType: 'ADDED' | 'DELETED' | 'MODIFIED' | 'UNCHANGED';
  oldQuestion?: any;
  newQuestion?: any;
  changes?: string[];
}

export interface VersionComparison {
  oldVersion: any;
  newVersion: any;
  questionDiffs: QuestionDiff[];
  addedCount: number;
  deletedCount: number;
  modifiedCount: number;
  unchangedCount: number;
}

export const versionService = {
  /**
   * 获取问卷的版本历史
   */
  async getVersionHistory(questionnaireId: number) {
    const response = await axios.get(
      `${API_BASE_URL}/admin/questionnaires/${questionnaireId}/versions`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('admin_token')}`,
        },
      }
    );
    return response.data.data;
  },

  /**
   * 对比两个版本
   */
  async compareVersions(
    questionnaireId: number,
    oldVersionId: number,
    newVersionId: number
  ): Promise<VersionComparison> {
    const response = await axios.get(
      `${API_BASE_URL}/admin/questionnaires/${questionnaireId}/versions/compare`,
      {
        params: { oldVersionId, newVersionId },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('admin_token')}`,
        },
      }
    );
    return response.data.data;
  },

  /**
   * 回退到指定版本
   */
  async rollbackToVersion(questionnaireId: number, targetVersionId: number) {
    const response = await axios.post(
      `${API_BASE_URL}/admin/questionnaires/${questionnaireId}/versions/rollback/${targetVersionId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('admin_token')}`,
        },
      }
    );
    return response.data.data;
  },
};
